export default "__VITE_ASSET__h7mV5uUQ__"